import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button } from 'base-ui'

import { StaticImage } from '../../../../../image'
import { urlResolverGetFreeEnvelopePdf } from '../../../../../url-handling'

import RedeemPrivateRx from './redeemPrivateRx.png'
import { RxLpComHowToRedeemInfoPoints } from './RxLpComHowToRedeemInfoPoints'

export const RX_HOW_TO_REDEEM_ANCHOR = 'how-to-redeem'

export const RxLpComHowToRedeem: FC = () => {
  return (
    <div className="bg-light-primary-medium" id={RX_HOW_TO_REDEEM_ANCHOR}>
      <div className="container flex flex-col gap-4 py-9 tablet:gap-6 tablet:py-12">
        <h2 className="text-center text-xl font-medium tablet:text-3xl">
          <FormattedMessage id="rx.com.redeem.title" />
        </h2>
        <div className="flex flex-col-reverse items-center gap-4 tablet:flex-row tablet:gap-12">
          <RxLpComHowToRedeemInfoPoints />
          <StaticImage
            alt="redeem private rx"
            // eslint-disable-next-line tailwindcss/no-arbitrary-value -- don't reference, refactor if touched
            className="w-[170px] tablet:w-[366px]"
            src={RedeemPrivateRx}
          />
        </div>
        <div className="flex flex-col items-center">
          <Button<'a'>
            className="w-full whitespace-normal tablet:min-h-14 tablet:w-fit tablet:text-m"
            data-qa-id="rx.com.redeem.cta"
            href={urlResolverGetFreeEnvelopePdf()}
            size="large"
            slots={{ root: 'a' }}
            target="_blank"
          >
            <FormattedMessage id="rx.com.redeem.cta" />
          </Button>
        </div>
      </div>
    </div>
  )
}
